import { createPurchaseAmendmentApi } from '#/api/srm/createPurchaseAmendmentApi';

import { serializeMiscPurchaseOrderAmendment } from './serialize';

/** 非庫存（雜項）採購異動單：僅 APPROVED 採購單可建立。 */
const api = createPurchaseAmendmentApi('/srm/misc-purchase-order', {
  serializeWrite: serializeMiscPurchaseOrderAmendment,
});

export const fetchMiscPurchaseOrderAmendmentList = api.fetchList;
export const fetchMiscPurchaseOrderAmendmentDetail = api.fetchDetail;
export const createMiscPurchaseOrderAmendment = api.create;
export const updateMiscPurchaseOrderAmendment = api.update;
export const deleteMiscPurchaseOrderAmendment = api.remove;
export const submitMiscPurchaseOrderAmendment = api.submit;
export const rejectMiscPurchaseOrderAmendment = api.reject;
export const approveMiscPurchaseOrderAmendment = api.approve;
